module.exports = __webpack_public_path__ + "static/media/beiyongzu.217ef765.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/beiyongzu.png
// module id = 753
// module chunks = 0